/* eslint-disable filenames/match-regex */
// Map View - components > map-view
export const MAP_FILTERS = {
  clear: 'Clear',
  done: 'Done',
  filterCategories: 'Categories',
  filterPriceShort: 'Price',
  refine: 'Refine',
};
export const MAP_VIEW_DEAL = {
  view: 'view',
  was: 'was',
};
export const MAP_VIEW_WIDGET = {
  mapTitle: 'Map',
  showOnMap: 'Show on Map',
};
